import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CrudService } from 'src/app/services/crud.service';
import { FilterComponent } from '../../filter/filter.component';
import { LoadingService } from '../../report-loading.service';
import { DateService } from 'src/app/services/date.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-media-plan-export',
  imports: [FilterComponent],
  providers: [ DateService, DatePipe ],
  templateUrl: './media-plan-export.component.html',
  styleUrls: ['./media-plan-export.component.css'],
  standalone: true
})
export class MediaPlanExportComponent {

  @Input() name: string;
  @Input() selectedFilter: string = '';

  filtered_by: string = '';
  filtered_by_promotion: string = '';
  disclaimer: string = '';

  constructor(private crudService: CrudService, 
    private loadingService: LoadingService) {

  }

  
  handleSelectedFilter(filter: string) {
    this.selectedFilter = filter;
  }

  async getPromoData(e: any) {
    if (!e.groupSelected) {
      return;
    }
    this.disclaimer = e.disclaimer;
    this.filtered_by = e.filtered.buying_group_name;
    this.filtered_by_promotion = e.promotionNameSelected;

    this.crudService.getExportData(
          `${environment.baseApiUrl}export/media-plan-products?promotion_period_id=${e.promotionSelected.value}&buying_group_id=${e.groupSelected.value}`,
          {},
          'blob'
        ).subscribe({
          next: (response: Blob) => {
            const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const downloadLink = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            downloadLink.href = url;
            downloadLink.download = 'Media_Plan_' + e.promotionNameSelected + '_' + this.filtered_by + '.xlsx';
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(url);
            this.loadingService.toggleLoading(false);
          },
          error: (error: any) => {
            console.error('Error:', error);
          }
        });
  }

}
